export default "__VITE_ASSET__CCEaenLE__"